import { GraphNode } from '../graph-node.js';
import { describeNodeData, traceGraph, traceGraphWarning } from '../debug.js';
/**
 * Exec Set for a mutable graph/local variable. Invalidates dependent value trees.
 */
export class SetVariableNode extends GraphNode {
    store;
    variableId;
    constructor(id, data, type, store) {
        super(id, data, type);
        this.store = store;
        this.variableId = typeof data.variableId === 'string' ? data.variableId : '';
    }
    async run() {
        this.getDataFromInPorts();
        const value = this.data.value;
        if (!this.store || !this.variableId) {
            traceGraphWarning(`setVariable (${this.id}) missing store or variableId`);
            this.data.value = value;
            this.triggerOutPort('exec');
            return;
        }
        if (this.store.isConst(this.variableId)) {
            traceGraphWarning(`setVariable (${this.id}) refused write to const ${this.variableId}`);
            this.data.value = this.store.get(this.variableId);
            this.triggerOutPort('exec');
            return;
        }
        this.store.set(this.variableId, value);
        this.data.value = value;
        this.invalidateDownstreamValueNodes();
        traceGraph(`setVariable (${this.id}) wrote`, {
            variableId: this.variableId,
            value: describeNodeData({ value }),
        });
        this.triggerOutPort('exec');
    }
    getOutPortData(outPortKey) {
        if (outPortKey === 'value')
            return this.data.value;
        return super.getOutPortData(outPortKey);
    }
    invalidateDownstreamValueNodes() {
        for (const connections of this.outConnections.values()) {
            for (const connection of connections)
                connection.connectedNode.markDirty();
        }
    }
}
